import { Directive, Input, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { Record } from '../models/record';
import { ConfigService } from '../services/config.service';

@Directive({
  selector: '[appRecordTitle]',
})
export class RecordTitleDirective implements OnChanges {
  @Input()
  appRecordTitle: Record;

  constructor(
    private _element: ElementRef,
    private configService: ConfigService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.appRecordTitle) {
      const current = changes.appRecordTitle.currentValue;
      const element = this._element.nativeElement as HTMLElement;
      if (current.title && current.title !== '') {
        element.innerHTML = current.title;
      }

      if (current.subtitle) {
        const separator = this.configService.get().titleSeparator;
        element.innerHTML += separator + ' ' + current.subtitle;
      }
    }
  }
}
